import React from "react";
import PropTypes from "prop-types";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

const TINTS = {
  info: { bg: "#e0f7fa", fg: "#00acc1" },
  primary: { bg: "#e8eaf6", fg: "#1a237e" },
  success: { bg: "#e8f5e9", fg: "#4caf50" },
  warning: { bg: "#fff3e0", fg: "#ff9800" },
  danger: { bg: "#ffebee", fg: "#f44336" }
};

function DialogHeader({ title, subtitle, icon, color, onClose }) {
  const tint = TINTS[color] || TINTS.primary;

  return (
    <DialogTitle disableTypography style={{ padding: 0, margin: 0 }}>
      <div style={{
        padding: "18px 24px",
        borderBottom: "1px solid #edf0f3",
        display: "flex",
        alignItems: "center",
        gap: "14px"
      }}>
        {icon && (
          <div style={{
            width: "36px",
            height: "36px",
            borderRadius: "10px",
            background: tint.bg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          }}>
            <Icon style={{ fontSize: "20px", color: tint.fg }}>{icon}</Icon>
          </div>
        )}
        <div style={{ flex: 1, minWidth: 0 }}>
          <h4 style={{ margin: 0, fontWeight: 600, fontSize: "17px", lineHeight: 1.3, color: "#1e293b" }}>
            {title}
          </h4>
          {subtitle && (
            <p style={{ margin: "3px 0 0", fontSize: "12.5px", color: "#94a3b8", fontWeight: 400 }}>
              {subtitle}
            </p>
          )}
        </div>
        {onClose && (
          <IconButton onClick={onClose} size="small" style={{ color: "#64748b", padding: "6px", marginRight: "-6px", backgroundColor: "#f1f5f9" }}>
            <Icon style={{ fontSize: "18px" }}>close</Icon>
          </IconButton>
        )}
      </div>
    </DialogTitle>
  );
}

DialogHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  icon: PropTypes.string,
  color: PropTypes.oneOf(["info", "primary", "success", "warning", "danger"]),
  onClose: PropTypes.func
};

export default DialogHeader;
